import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TabPanelDisplayMode } from 'app/components/enums/TabPanelDisplayMode';
import { NotesComponent } from '../notes/notes.component';
import { OpenTicketsComponent } from '../OpenTickets/OpenTickets.component';

@Component({
	selector: 'app-components-managecustomer-notesandtickets',
	templateUrl: './notes-and-tickets.component.html'
})
export class NotesAndTicketsComponent {
    @ViewChild(OpenTicketsComponent) ticketsComponent: OpenTicketsComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @Input() customer: Boo.Objects.Customer;
    @Output() refreshCustomer = new EventEmitter<void>();
    tabPanelDisplayMode = TabPanelDisplayMode;

    public reloadNotes(): void {
        this.notesComponent.dataTable.reload();
    }

    public reloadTickets(): void {
        this.ticketsComponent.loadTickets();
    }
}
